module.exports = __webpack_public_path__ + "img/pic13.a44a37e7.jpg";